<script>
import {M} from "../external";

export let message = M.NO_DATA_YET;
</script>

<div class="col20 f-left coming-soon-block">
	<div class="col20 f-left t-center mb-25">
		<span class="material-icons-outlined fingerprint-icon" style="background: #f5f6fa;"> bubble_chart </span>
	</div>
	<div class="col20 f-left t-center">
		<h3>{message}</h3>
	</div>
</div>
